module.exports = __webpack_public_path__ + "img/qualityFactors.fe8655f.png";